/** String constant used to reset an individual config property. */
const RESET: string = "D3PLUS-COMMON-RESET";
export default RESET;
